import { FunctionComponent } from 'react';
import { Field } from 'formik';
import { Autocomplete, AutocompleteProps } from '@mui/material';

type AutocompleteFieldProps<T> = {
    name: string;
    onChange: (option: T[]) => void;

    valueTransformHandler?: (values: unknown[]) => T[];
} & AutocompleteProps<T, boolean, boolean, boolean>;

export const AutocompleteField: FunctionComponent<
    AutocompleteFieldProps<unknown>
> = ({ name, onChange, valueTransformHandler, ...rest }) => {
    return (
        <Field name={name}>
            {({ field }) => {
                const { value } = field;

                const valueToUse = valueTransformHandler
                    ? valueTransformHandler(value)
                    : value;
                return (
                    <Autocomplete
                        {...rest}
                        multiple
                        filterSelectedOptions
                        value={valueToUse}
                        defaultValue={valueToUse}
                        onChange={(_event, selectValue) => {
                            onChange(selectValue);
                        }}
                    />
                );
            }}
        </Field>
    );
};
